import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod/v4";
import { FullPageSpinner } from "@/components/basics/full-page-spinner";

const searchSchema = z.object({
  error: z.string().optional(),
  error_description: z.string().optional(),
});

export const Route = createFileRoute("/auth/callback")({
  validateSearch: searchSchema,
  component: AuthCallback,
});

function AuthCallback() {
  const { error, error_description } = Route.useSearch();

  if (error) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-4">
        <h1 className="text-2xl font-semibold">Authentication error</h1>
        <p className="text-muted-foreground">{error_description ?? error}</p>
      </div>
    );
  }

  return <FullPageSpinner />;
}
